import { render, staticRenderFns } from "./QuerySurvey.vue?vue&type=template&id=dbb3a2c6&scoped=true"
import script from "./QuerySurvey.vue?vue&type=script&lang=js"
export * from "./QuerySurvey.vue?vue&type=script&lang=js"
import style0 from "./QuerySurvey.vue?vue&type=style&index=0&id=dbb3a2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb3a2c6",
  null
  
)

export default component.exports